// extracted by mini-css-extract-plugin
module.exports = {"header":"submenu_header__2hD18","linkParagraph":"submenu_linkParagraph__UrHbO"};